/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-10 12:29:02
 * @Explain: 活动
 */
export default {
  // 活动列表
  'ACTIVITY.MANAGE.LIST.TITLE': 'Campaigns list',
  'ACTIVITY.MANAGE.LIST.CREATE.CAMPAIGN': 'Create campaign',
  'ACTIVITY.MANAGE.LIST.TASK.NAME': 'Name',
  'ACTIVITY.MANAGE.LIST.CHANNEL': 'Reach channel',
  'ACTIVITY.MANAGE.LIST.EDITOR': 'Edited by',
  'ACTIVITY.MANAGE.LIST.TIME.ZONE': 'Time zone',
  'ACTIVITY.MANAGE.LIST.START.TIME': 'Start time',
  'ACTIVITY.MANAGE.LIST.ACTIVITY.START.TIME': 'Campaign start time',
  'ACTIVITY.MANAGE.LIST.END.TIME': 'End time',
  'ACTIVITY.MANAGE.LIST.UPDATE.TIME': 'Last edited',
  'ACTIVITY.MANAGE.LIST.VERIFY.STATUS': 'Verification status',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS': 'Status',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS1':
    'Variable value is missing, campaign has been paused',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS2':
    'Click on the key name to upload the variable value for it:',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS3':
    'The maximum number of emails within 24 hours has been reached. This balance will be refreshed  automatically and afterwards the campaign will start again.',
  'ACTIVITY.MANAGE.LIST.STATUS.DESC': 'Campaign status description',
  'ACTIVITY.MANAGE.LIST.RECIPIENTS': 'Recipients',
  'ACTIVITY.MANAGE.LIST.DATA.UPDATE.TIME': 'Update time',
  'ACTIVITY.MANAGE.LIST.SEND.PROGRESS': 'Progress',
  'ACTIVITY.MANAGE.LIST.CAMPAIGN.NOT.STARTED': 'Not yet started',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED': 'Delivery speed',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED.TIPS1':
    'The delivery speed can change when external conditions change.',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED.TIPS2':
    'The estimated completion time will then be updated accordingly.',
  'ACTIVITY.MANAGE.LIST.SEAL.SECOND': '<b>{num}</b> emails/second',
  'ACTIVITY.MANAGE.LIST.ESTIMATED.TIME.OF.END': 'Estimated completion time',
  'ACTIVITY.MANAGE.LIST.NO.CYCLE.USER':
    'There are no eligible contacts anymore in the current cycle',
  'ACTIVITY.MANAGE.LIST.CYCLE.NOT.ACTIVE': 'Periodic campaign was not sent out',
  'ACTIVITY.MANAGE.LIST.PAUSE.CYCLE.NOT.ACTIVE':
    'The sending time of this cycle was missed, and it has been manually confirmed to skip this cycle.',
  'ACTIVITY.MANAGE.LIST.CYCLE': 'Cycle',
  'ACTIVITY.MANAGE.LIST.DELETE.CAMPAIGN.TIPS':
    'Used in if/else point of Journey {campaignName}',

  'ACTIVITY.MANAGE.LIST.WINNER.DELIVERY.IN.PROGRESS':
    'Winner delivery in progress',
  'ACTIVITY.MANAGE.LIST.WAITLIST': 'Waiting for delivery',
  'ACTIVITY.MANAGE.LIST.WAITLIST.NOTES':
    "Ongoing campaign, waiting for delivery to the recipients' time zone or for their 'Email frequency control' to have ended.",
  'ACTIVITY.MANAGE.LIST.RECOVER.REMAINING.TIME':
    "<span class='color-d6'>Waiting for delivery to the next time zone or for the 'Email frequency control' to end.</span><br/><b> Next delivery in {time}.</b>",
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS.SENDING': 'Test in progress (sending)',
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS.PENDING.WINNER.SELECTION':
    'Test in progress (pending winner selection)',
  'ACTIVITY.MANAGE.LIST.WAITING.FOR.EXECUTION': 'Waiting for execution',
  'ACTIVITY.MANAGE.LIST.SCHEDULED.NOTES':
    'The campaign is successfully published but has not reached the scheduled delivery time, pending initiation‌.',
  'ACTIVITY.MANAGE.LIST.TESTINPROGRESS': 'Test in progress',
  'ACTIVITY.MANAGE.LIST.TESTINPROGRESS.NOTES':
    'The A/B test campaign has started delivery of test groups, awaiting selection of the winning group.',
  'ACTIVITY.MANAGE.LIST.TERMINATED': 'Completed',
  'ACTIVITY.MANAGE.LIST.TERMINATED.NOTES':
    'The campaign was completed normally.',
  'ACTIVITY.MANAGE.LIST.TERMINATION.NOTES':
    'The campaign was terminated manually.',
  'ACTIVITY.MANAGE.LIST.HAVE.ON.GOING': 'Ongoing',
  'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND': 'Sending',
  'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND.NOTES':
    'The campaign is successfully published and has entered active delivery phase upon reaching scheduled time‌.',
  'ACTIVITY.MANAGE.LIST.UNPUBLISHED': 'Draft',
  'ACTIVITY.MANAGE.LIST.UNPUBLISHED.NOTES':
    'The campaign is successfully created, but not directly launched or not requested for launch.',
  'ACTIVITY.MANAGE.LIST.START': 'Resume',
  'ACTIVITY.MANAGE.LIST.NOT.STARTED': 'Not started',
  'ACTIVITY.MANAGE.LIST.SUSPENDED': 'Paused',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.NOTES':
    'Campaign has been paused manually and is currently not delivering emails.',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER': 'Interrupted',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER.NOTES':
    'Sending campaign, but delivery was interrupted because there was an issue (e.g. missing keys).',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL': 'Pending approval',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.NOTES':
    'The campaign has requested for launch and is waiting for approval.',
  'ACTIVITY.MANAGE.LIST.FAILED': 'Failed',
  'ACTIVITY.MANAGE.LIST.VERIFIED': 'Verified',
  'ACTIVITY.MANAGE.LIST.NOT.VERIFIED': 'Not verified',
  'ACTIVITY.MANAGE.LIST.VERIFYING': 'Verifying',
  'ACTIVITY.MANAGE.LIST.SELECT.TIME': 'Select time',
  'ACTIVITY.MANAGE.LIST.SEARCH.TASK.NAME': 'Search campaign',
  'ACTIVITY.MANAGE.LIST.DELETE.HEADER': 'Delete campaign',
  'ACTIVITY.MANAGE.LIST.DELETE.CONTENT':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.HEADER': 'Bulk delete campaigns',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONTENT':
    "<b class='color-333'>'<span>{num}</span>'</b> campaign(s) selected. The selected campaign(s) will be permanently deleted and cannot be restored.",
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONFIRM': 'Type <b>DELETE</b> to confirm',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONFIRM.TEXT': 'DELETE',
  'ACTIVITY.MANAGE.LIST.DELETE.TIPS':
    'Select the campaigns you want to delete.',
  // 'ACTIVITY.MANAGE.LIST.REVOKE.MSG': 'Undo {name}？',
  'ACTIVITY.MANAGE.LIST.REVOKE.TITLE': 'Revoke campaign',
  'ACTIVITY.MANAGE.LIST.REVOKE.MSG':
    "Campaign <b class='color-333'>'<span>{name}</span>'</b> has already been submitted for approval. Revoking this campaign will cancel the approval request.",
  'ACTIVITY.MANAGE.LIST.START.TITLE': 'Restart campaign',
  'ACTIVITY.MANAGE.LIST.START.TIPS': 'Restart campaign {name}',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.TIPS': 'Suspend task {name}',
  'ACTIVITY.MANAGE.LIST.TERMINATION.TIPS':
    'Terminate task "{name}", and the task will no longer execute',

  'ACTIVITY.MANAGE.LIST.TIMEZONE': 'Time zone',
  'ACTIVITY.MANAGE.LIST.START.DELIVERY.TIME1': 'Start time (Local Time)',
  'ACTIVITY.MANAGE.LIST.START.DELIVERY.TIME2': 'Start time',

  'ACTIVITY.MANAGE.LIST.ACTIVITY.DETAILS': 'Campaign details',
  'ACTIVITY.MANAGE.LIST.APPROVAL.DETAILS': 'Approval details',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS': 'Cycle details',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.RELEASE': 'Scheduled campaigns',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.EDIT': 'Modified campaigns',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.ENDS.AT': 'Ends at',
  'ACTIVITY.MANAGE.LIST.ALL.WEIGHT.REMOVAL': 'Multiple deliveries not allowed',
  'ACTIVITY.MANAGE.LIST.WEIGHT.IN.DAYS':
    'Multiple deliveries not allowed within {num} day(s)',
  'ACTIVITY.MANAGE.LIST.PERIOD.NUM': 'Cycle {num}',
  'ACTIVITY.MANAGE.LIST.UNSENT': 'Not sent',
  'ACTIVITY.MANAGE.LIST.BEING.SENT': 'Sending',
  'ACTIVITY.MANAGE.LIST.SENT': 'Sent',
  'ACTIVITY.MANAGE.LIST.UNSENT.REASON': 'Campaign suspended, cycle skipped',
  'ACTIVITY.MANAGE.LIST.TOTAL.PEOPLE.SENT':
    'Emails sent <b class="ml-4">{num}</b>',
  'ACTIVITY.MANAGE.LIST.APPROVAL.STATUS': 'Approval status',
  'ACTIVITY.MANAGE.LIST.COPY.APPROVAL.LINK': 'copy the link',
  'ACTIVITY.MANAGE.LIST.COPY.APPROVAL.TEXT':
    'Hi there,\r\nA campaign requires your approval.\r\nProject: {gameName}\r\nCampaign name: {activityName}\r\nSubmitted by: {activityCreator}\r\nTime of request: {createTime}\r\nQuick approval link: {checkLink}',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS1':
    'The campaign launch request has been submitted and the following administrators can approve this request. To speed up the approval process, you can: ',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS2': ' execute',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS3':
    'Remind administrators to approve this request.',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS4':
    'If the campaign information needs to be changed, ask an administrator to reject this request.',
  'ACTIVITY.MANAGE.LIST.VIEW.REPORT': 'View report',
  'ACTIVITY.MANAGE.LIST.APPROVED.STATUS': 'Approval status',
  'ACTIVITY.MANAGE.LIST.APPROVED.BY': 'Approved by',
  'ACTIVITY.MANAGE.LIST.APPROVED.TIME': 'Approval time',
  'ACTIVITY.MANAGE.LIST.REASON.FOR.PASSING': 'Approval comment',
  'ACTIVITY.MANAGE.LIST.REASON.FOR.FAILURE': 'Rejection reason',
  'ACTIVITY.MANAGE.LIST.REJECTED.RE.ISSUED':
    'After a campaign is rejected, it can be adjusted and then launched again.',
  'ACTIVITY.MANAGE.LIST.SCHEDULED': 'Scheduled',
  'ACTIVITY.MANAGE.LIST.REVOKE.SCHEDULED.CONTENT':
    "Campaign <b class='color-333'>'<span>{tag}</span>'</b> has already been launched. Revoking this campaign will cancel the email delivery.",
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS': 'Test in progress',
  'ACTIVITY.MANAGE.LIST.PROGRESS': 'Progress',
  'ACTIVITY.MANAGE.LIST.WINNING.SETUP.SENT.AT': 'Winner delivery time',
  'ACTIVITY.MANAGE.LIST.SELECT.MANUALLY': 'Select manually',
  'ACTIVITY.MANAGE.LIST.ONGING': 'Ongoing',
  'ACTIVITY.MANAGE.LIST.END': 'Ended',
  // 'ACTIVITY.MANAGE.LIST.AUTOMATIC.SELECTION': '自动选择',
  'ACTIVITY.MANAGE.LIST.HOW.MANY.HOURS':
    '{num} hour(s) after test is completed',
  'ACTIVITY.MANAGE.LIST.HOW.MANY.DAYS': '{num} day(s) after test is completed',

  // 活动管理 - 列表 - 创建活动
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY': 'Create campaign',
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY.NAME': 'Campaign name',
  'ACTIVITY.MANAGE.LIST.CREATE.PLEASE.ENTER.ACTIVITY.NAME':
    'Enter campaign name',
  'ACTIVITY.MANAGE.LIST.CREATE.PLEASE.ENTER.ACTIVITY.NAME.ERROR.EMOJI':
    "Campaign name can't have any emojis",
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY.DESC1':
    'Create and launch campaigns within a few minutes. Select the sender, recipients, mail template, and set a delivery time.',

  // 活动管理 - 创建活动 - 完成配置
  'ACTIVITY.MANAGE.CREATE.COMPLETE.CONFIG.TITLE': 'Campaign preparations',
  'ACTIVITY.MANAGE.CREATE.COMPLETE.CONFIG.TIPS':
    'Before sending out emails with SmartLink, your domain needs to be verified.',
  'ACTIVITY.MANAGE.CREATE.TO.CREATE': 'Create',
  'ACTIVITY.MANAGE.CREATE.TO.VERIFY': 'Verify',
  'ACTIVITY.MANAGE.CREATE.TO.IMPORT': 'Import',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT': 'Import contacts',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT.TIPS1':
    'The list of contacts contains all potential recipients for your campaigns.',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT.TIPS2':
    'SmartLink allows you to select recipients based on tags or segmentation rules. To set up these rules, import your contacts and then associate them with certain tags or create specific segmentation rules.',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME': 'Verify your domain',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME.TIPS1':
    'Your domain is the part of an email address that comes after the “@” symbol.',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME.TIPS2':
    'The domain name needs to be verified before SmartLink can send out emails.',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP': 'Create email template',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP.TIPS1':
    'The email template is the content of your campaign email. A single campaign can send out emails in different languages by using multiple templates.',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP.TIPS2':
    'By creating templates in advance, you can simply select the email content you want to send when creating a campaign.',
  'ACTIVITY.MANAGE.CREATE.NO.CONTACTS': 'No contacts yet?',
  'ACTIVITY.MANAGE.CREATE.NO.CONTACTS.TIPS':
    "Make your life easier by creating contacts. We'll walk you through this.",
  'ACTIVITY.MANAGE.CREATE.CREATE.CONTACTS': 'Create contact',

  // 活动管理 - 创建活动 - 操作按钮（草稿、发送测试邮件、现在发送、申请发布）
  'ACTIVITY.MANAGE.CREATE.SAVE.QUIT': 'Save and exit',
  'ACTIVITY.MANAGE.CREATE.SAVE.QUIT.TIPS': 'Please confirm the changes made',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT': 'Draft saved at {time}',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT.TITLE': 'Unsaved changes',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT.DESC':
    'Changes will be lost if you leave without saving.',
  'ACTIVITY.MANAGE.CREATE.SEND.NOW': 'Schedule',
  'ACTIVITY.MANAGE.CREATE.APPLICATION.RELEASE': 'Request to launch',
  'ACTIVITY.MANAGE.PUBLISH.TIPS': 'Complete all steps before sending out email',
  'ACTIVITY.MANAGE.PUBLISH.WHATSAPP.TIPS':
    'Complete all steps before sending out message',
  'ACTIVITY.MANAGE.CREATE.SUBMIT.RELEASE.APPLY': 'Request campaign launch',
  'ACTIVITY.MANAGE.CREATE.SUBMIT.RELEASE.APPLY.TIPS1':
    "After submitting your request, you can view the approval status under 'Pending approval'. This campaign will only be launched after it has been approved.",
  'ACTIVITY.MANAGE.CREATE.DIRECT.RELEASE.ACTIVITY': 'Launch campaign',
  'ACTIVITY.MANAGE.CREATE.DIRECT.RELEASE.ACTIVITY.TIPS1':
    'After the campaign is launched, its content cannot be changed anymore. It is recommended to send a test email before launching the campaign.',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.LABEL': 'Select campaign purpose',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.PREFIX.LABEL': 'Purpose',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.SELECT': 'Select campaign purpose',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.ENTER': 'Enter campaign purpose',
  'ACTIVITY.MANAGE.CREATE.TEST.PERIOD': 'Test period',
  'ACTIVITY.MANAGE.CREATE.PLAYER.ACTIVATION': 'Player activation',
  'ACTIVITY.MANAGE.CREATE.PLAYER.PAYMENT': 'Player payment',
  'ACTIVITY.MANAGE.CREATE.OTHERS': 'Others',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.TIPS1':
    'Select the purpose of this campaign to get more accurate performance analyses. The purpose selected will only be used in campaign reports and will not be disclosed to third parties.',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TITLE':
    "Ignore 'Email frequency controls'",
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS1':
    'Tick this box if the emails sent in this campaign should not count towards the email limitations. ',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS2': 'Click here ',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS3':
    "to open the 'Email frequency controls' page.",
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.SIGN.ON':
    "Following the <a href={url} target='_black'>'Email frequency controls'</a>",
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.SIGN.OFF':
    "Ignoring the <a href={url} target='_black'>'Email frequency controls'</a>",

  // 预览并测试 - 验证活动 - start
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEST': 'Preview and test',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEST.TIPS':
    'Complete all steps to view the preview',
  'ACTIVITY.MANAGE.TEST.MAIL.SEND.FOR.TEST': 'Send test email',
  'ACTIVITY.MANAGE.TEST.MAIL.SEND.TEST.LIST':
    'Send test email to the following recipients',
  'ACTIVITY.MANAGE.ENTER.VERIFY.MAILBOX': "Enter testers' email addresses",
  'ACTIVITY.MANAGE.PLEASE.ENTER.VERIFY.MAILBOX':
    "Please enter testers' email address",
  'ACTIVITY.MANAGE.SUBMIT.TOTAL.MAIL':
    '<b class="ml-5 mr-5">{num}</b> testers\' email addresses in total',
  'ACTIVITY.MANAGE.SEND.TEST.EMAIL': 'Send test email',
  'ACTIVITY.MANAGE.SEND.MAIL': 'Send test email',
  'ACTIVITY.MANAGE.MAIL.SEND.COMPLETE': 'Email sent successfully',
  'ACTIVITY.MANAGE.MAIL.SEND.RESULT':
    'Template email sent successfully, please check.',
  'ACTIVITY.MANAGE.VERIFY.PASSED': 'Verification successful',
  'ACTIVITY.MANAGE.VERIFY.FAILED': 'Verification failed',
  'ACTIVITY.MANAGE.SUBMIT.VERIFY.RESSULTS.LATER':
    'Submit verification results later',
  'ACTIVITY.MANAGE.SELECT.VERIFY.EMAIL':
    "Please select the verifier's email address",
  'ACTIVITY.MANAGE.ENTER.VERIFY.EMAIL': 'Enter email address',
  'ACTIVITY.MANAGE.ENTER.VERIFY.EMAIL.EMPTY': 'Field cannot be empty',
  'ACTIVITY.MANAGE.TEMPLATE.VAR': 'Template variable',
  'ACTIVITY.MANAGE.VAR': 'Variable',
  'ACTIVITY.MANAGE.REPLACE.WITH': 'Replace with',
  'ACTIVITY.MANAGE.VAR.REPLACE.WITH':
    'Variable <b class="color-333">{name}</b> replace with',
  'ACTIVITY.MANAGE.PLEASE.ENTER.REPLACE.VALUE': 'Enter a replacement value',
  'ACTIVITY.MANAGE.DEFAULT.VAR.TIPS':
    '{var} is the default variable, it can be replaced if needed',
  'ACTIVITY.MANAGE.CLICK.VERIFY.MAIL.MANAGE':
    'Click testers email management to add a tester',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS1':
    'None of the recipients is familiar with this language. You can make changes in',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS2': 'Project settings > Testers',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS3':
    'if needed. Or manually fill in tester emails below.',
  'ACTIVITY.MANAGE.SEND.TEST.TIPS':
    'Send a test email to the recipients listed below to review the email content. It is recommended to send to recipients for languages that may be used in future campaign emails.',
  'ACTIVITY.MANAGE.SEND.NOW': 'Send now',
  'ACTIVITY.MANAGE.TEST.MAIL.FROM': 'From',
  // 预览并测试 - 验证活动 - end

  // 活动管理 - 创建活动 - 提交验证
  'ACTIVITY.MANAGE.DATA.EXCEPTION': 'Data error, check {module}',
  'ACTIVITY.MANAGE.BE.DEL.REGION':
    '{name} region is incorrect, please check {module}',

  // 活动管理 - 创建活动 - 标题
  'ACTIVITY.MANAGE.CREATE.NAME': 'Campaign name',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME': 'Enter the campaign name',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME.DISABLED': 'Enter the campaign name',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME.LIMIT':
    'The character limit for the campaign name is 50 characters',

  // 活动管理 - 创建活动 - 发送给
  'ACTIVITY.MANAGE.TO': 'Recipients',
  'ACTIVITY.MANAGE.TO.TIPS': 'Select recipients',
  'ACTIVITY.MANAGE.TO.TIPS1':
    'Number is updated automatically after campaign is launched',
  'ACTIVITY.MANAGE.STATISTICS.SUBSCRIBERS': 'subscribers',
  'ACTIVITY.MANAGE.STATISTICS.CONTACTS': 'contacts',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO': 'Send to',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO.PLACEHOLDER': 'Select recipients',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO.SEARCH.PLACEHOLDER': 'Search',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT': 'Target audience',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.LIST.NAME':
    'Target audience {num}',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.TIPS':
    'Target audience created in a campaign can only be used in that campaign',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.CREATE':
    'Create target audience',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.EDIT': 'Edit target audience',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.VIEW': 'Preview',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.VIEW.TIPS':
    'Please complete the rule creation first.',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.SUB': 'Confirm',
  'ACTIVITY.MANAGE.COUNTRY.LANG.STATISTICS':
    '<b class="color-primary font-size-20 font-poppins">{total}</b> recipients',
  'ACTIVITY.MANAGE.CONTACTS.WITH.TAG': 'Tags',
  'ACTIVITY.MANAGE.SEGMENT': 'Segments',
  'ACTIVITY.MANAGE.ALL.CONTACTS': 'All contacts',
  'ACTIVITY.MANAGE.PLEASE.ALL.CONTACTS': 'Select your recipients',
  'ACTIVITY.MANAGE.SUBSCRIBERS': 'Subscribers',
  'ACTIVITY.MANAGE.ALL.CONTACTS.AND.OTHER':
    'All contacts (regardless of subscription statuses)',
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.HEADER':
    "Select 'All contacts (regardless of subscription statuses)'",
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.TIPS1':
    "You are going to send emails to all contacts which includes contacts who are 'Subscribed', 'Unsubscribed' and 'Non-subscribed'.",
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.TIPS2':
    "Please note that sending emails to 'Unsubscribed' and 'Non-subscribed' contacts may result in your email being reported as spam. Make sure it is necessary to send this email to all your contacts.",
  'ACTIVITY.MANAGE.ALL.CONTACTS.DETAILS':
    'Subscription status (<span class="color-999">{typeText}</span>):',
  'ACTIVITY.MANAGE.PLEASE.SELECT.SEGMENT': 'Select your segment',
  'ACTIVITY.MANAGE.EXPECTED.DELIVERY.DAYS1':
    '<b class="font-size-20 font-poppins">{num} days</b> emails are expected to be delivered to all contacts within',
  'ACTIVITY.MANAGE.ST.NUMBER.OF.PEOPLE': 'Count',
  'ACTIVITY.MANAGE.ST.RATIO': 'Ratio',
  'ACTIVITY.MANAGE.CONTACT.LIST': 'Contact list',
  'ACTIVITY.MANAGE.CREATE.TAG': 'Create a new tag',
  'ACTIVITY.MANAGE.CREATE.SEGMENT': 'Create a new segment',
  'ACTIVITY.MANAGE.BE.DEL.TAG': '{name} tag has been removed',
  'ACTIVITY.MANAGE.BE.DEL.SEGMENT': '{name} segment has been removed',

  // 活动管理 - 创建活动 - 来自
  'ACTIVITY.MANAGE.FROM': 'Sender',
  'ACTIVITY.MANAGE.FROM.TIPS': 'Set the sender details for this campaign',
  'ACTIVITY.MANAGE.PLEASE.SELECT.FROM.NAME': "Select the sender's name",
  'ACTIVITY.MANAGE.PLEASE.SELECT.PREFIX.EMAIL.ADDRESS':
    "Select the sender's address",
  'ACTIVITY.MANAGE.PLEASE.SELECT.DOMAIN': "Select the sender's domain",
  'ACTIVITY.MANAGE.PLEASE.ENTER.DOMAIN':
    'Enter the domain name for the email address',
  'ACTIVITY.MANAGE.VERIFY.DOMAIN': 'Verify domain',
  'ACTIVITY.MANAGE.VERIFY.UNVERIFIED.DOMAIN': 'Domain Not Verified',
  'ACTIVITY.MANAGE.CREATE.NEW.SENDER.NAME': 'Create a new sender name',
  'ACTIVITY.MANAGE.CREATE.NEW.SENDING.ADDRESS': 'Create a new email address',
  'ACTIVITY.MANAGE.CREATE.NEW.DOMAIN.NAME': 'Create a new domain name',
  'ACTIVITY.MANAGE.CREATE.SENDER': 'Sender',
  'ACTIVITY.MANAGE.CREATE.SENDER.TIPS':
    'Select sender name (e.g. your company name) to help recipients recognize your email.',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDER': 'Enter or select a sender',
  'ACTIVITY.MANAGE.CREATE.SENDER.NAME': 'Sender name',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDER.NAME': "Enter sender's name",
  'ACTIVITY.MANAGE.CREATE.SENDER.MANAGE': 'Frequent sender management',
  'ACTIVITY.MANAGE.CREATE.SENDER.ADDRESS.DELTIPS':
    'Are you sure you want to delete this sender?',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS': 'Sender address',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.TIPS':
    "Select the email address that appears in the recipient's inbox when receiving your campaign.",
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDING.ADDRESS':
    "Enter sender's address",
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.MANAGE':
    'Frequent Sender Address Management',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.DELTIPS':
    "Are you sure you want to delete this sender's address?",
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.MAIL.PREFIX':
    'Enter or select a username',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.MAIL.SUFFIX': 'Select an email domain',
  'ACTIVITY.MANAGE.CREATE.INBOX': 'Inbox',
  'ACTIVITY.MANAGE.CREATE.EMAIL.PROJECT': 'Message subject...',
  'ACTIVITY.MANAGE.CREATE.YOU.PREVIEW.TEXT': 'Your preview text',
  'ACTIVITY.MANAGE.CREATE.MESSAGE.SUBJECT.AND.CONTENT':
    'Subject line & preview text...',
  'ACTIVITY.MANAGE.CREATE.INBOX.TIPS':
    'Actual email display may vary on different email clients.',
  'ACTIVITY.MANAGE.CREATE.SENDING.SUBSCRIPTION_TITlE':
    'Enable list-unsubscribe',
  'ACTIVITY.MANAGE.CREATE.SENDING.SUBSCRIPTION_MSG':
    "After enabling this feature, recipients can unsubscribe with one click on the inbox list of the client. For information on which clients are supported, please refer to the user manual.<a href={url} target='_black'>View details</a>",

  // 活动管理 - 创建活动 - 选择内容
  'ACTIVITY.MANAGE.CONTENT': 'Content',
  'ACTIVITY.MANAGE.CONTENT.TIPS':
    'Fill in the subject and select a template for each language',
  'ACTIVITY.MANAGE.AB.TEST.CONTENT.TIPS':
    'Select a templates for each language preference',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.LANGUAGE': 'Default language',
  'ACTIVITY.MANAGE.CREATE.MAIL.CONTENT': 'Email content',
  'ACTIVITY.MANAGE.CREATE.MAIL.WHATSAPP.TEMPLATE': 'WhatsApp template',
  'ACTIVITY.MANAGE.CREATE.MAIL.SUBJECT': 'Subject',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.MAIL.SUBJECT': 'Enter the subject',
  'ACTIVITY.MANAGE.CREATE.SUBJECT.EXIST':
    'The currently entered topic already exists',
  'ACTIVITY.MANAGE.CREATE.SUBJECT.REPETITION':
    'There are duplicates in the {lang} topic',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEXT': 'Preview text',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEXT.TIPS':
    'If left empty, the first text in the template will be shown.',
  'ACTIVITY.MANAGE.CREATE.REPLY.TO.TEXT': 'Reply to',
  'ACTIVITY.MANAGE.CREATE.REPLY.TO.TIPS': 'Please enter contact email',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.PREVIEW.TEXT': 'Enter the preview text',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.PREVIEW.TEXT.TIPS':
    'Appears in the inbox after the subject line',
  'ACTIVITY.MANAGE.CREATE.XX.LANGUAGE.RECIPIENTS': '{lang} Recipient(s)',
  'ACTIVITY.MANAGE.CREATE.MAIL.TEMPLATE': 'Template',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.TEMPLATE': 'Select Marketing Template',
  'ACTIVITY.MANAGE.CREATE.TEMPLATE.TIME.SAVE': '{time} saved',
  'ACTIVITY.MANAGE.CREATE.PLEASE.CHECK.TEMPLATE':
    'Check if the email template meets all requirements',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TITLE': 'Template checklist',
  'ACTIVITY.MANAGE.CONTENT.ERROR.DETECTED': 'Error detected',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS1': 'Unsubscribe link needs to be added.',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS1.1': 'Unsubscribe link has been added',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS2':
    'Detected  uncreated keys / contact attributes',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS2.1': 'All keys have been created',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS3': 'Template has been deleted',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS4':
    'Keys used in this template: <p class="red-dot created-var" title={variable}>{variable}</p>',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS4.1':
    'Make sure each placeholder has sufficient values available before launching a campaign. If any placeholder is depleted, your campaign will be suspended.',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS5': 'Template contains inactive form(s)',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS6':
    'Detected  uncreated contact attributes',
  'ACTIVITY.MANAGE.CONTENT.COPY.LINK': 'Copy link',
  'ACTIVITY.MANAGE.CONTENT.COPY.LINK.DETAILS':
    'Complete link configuration first.',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS6.1': 'No invitation link added.',

  'ACTIVITY.MANAGE.CONTENT.EDIT.TEMP': 'Edit template',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.PER': 'Personal information',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.TITLE': 'Insert personal information',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.DESC':
    'Select a dynamic value placeholder',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.ADD': 'Add placeholder',
  'ACTIVITY.MANAGE.CREATE.ETC.CONTENTS': 'Total email templates: {num}',
  'ACTIVITY.MANAGE.CREATE.LANGUAGES': 'Language(s)',
  'ACTIVITY.MANAGE.CREATE.FILLED.IN.NUM': 'Completed',
  'ACTIVITY.MANAGE.SET.BY.LANGUAGE.TIPS':
    "lf the recipient's language is unknown or if no template is created for the recipient's language, the template in this language will be sent to the recipient.",

  // 活动管理 - 创建活动 - 时间安排
  'ACTIVITY.MANAGE.SCHEDULE': 'Delivery schedule',
  'ACTIVITY.MANAGE.SCHEDULE.TIPS': 'Schedule your campaign',
  'ACTIVITY.MANAGE.AB.TEST.SCHEDULE.TIPS': 'Schedule your test',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE': 'Schedule',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE.DESC':
    'The delivery option selected below will determine the delivery timing of emails after the winner is decided on. ',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE.TIPS':
    "When selecting 'Global Fixed Time', the winning variation will start being delivered immediately after the test phase.<br />When selecting 'Region Fixed Time' or 'Optimal Delivery Time', the winning variation will start being delivered at the selected local times.",
  'ACTIVITY.MANAGE.RADIO.SEND.NOW': 'Send now',
  'ACTIVITY.MANAGE.DELIVER.TIME': 'Delivery time',
  'ACTIVITY.MANAGE.DUPLICATE.REMOVAL': 'Send email to all eligible recipients',
  'ACTIVITY.MANAGE.NOT.DUPLICATE.REMOVAL':
    'Send email to recipients who have not received this email before',
  'ACTIVITY.MANAGE.CREATE.NEW.SCHEDULE': 'Create new schedule',
  'ACTIVITY.MANAGE.SCHEDULE.NUM': 'Schedule {num}',

  'ACTIVITY.MANAGE.CREATE.DELIVERY.TIME': 'Delivery time',
  'ACTIVITY.MANAGE.CREATE.FIXED.TIME.ZONE': 'Global Fixed Time',
  'ACTIVITY.MANAGE.CREATE.SELECT.TIME.ZONE': 'Select time zone',
  'ACTIVITY.MANAGE.CREATE.SELECT.START.DELIVERY.TIME': 'Delivery time',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.SCHEDULE': 'Default delivery time',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.SCHEDULE.TIPS':
    'Unidentified countries and countries that have not been set will receive the email at this default delivery time.',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.DEFAULT.SCHEDULE':
    'Set the default delivery time',
  'ACTIVITY.MANAGE.CREATE.STOP.DELIVERY.TIME': 'End time',
  'ACTIVITY.MANAGE.CREATE.CYCLE.SETTING': 'Cycle settings',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.TITLE':
    'Settings for multiple deliveries',
  'ACTIVITY.MANAGE.CREATE.DUPLICATE.REMOVAL': 'Multiple deliveries not allowed',
  'ACTIVITY.MANAGE.CREATE.NO.WEIGHT.LOSS': 'Multiple deliveries allowed',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.1':
    'Multiple deliveries never allowed',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.2':
    'Multiple deliveries not allowed within the following number of day(s)',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.DAY': 'Enter number of day(s)',
  'ACTIVITY.MANAGE.CREATE.ENTER.MIN.DAY':
    'Please enter more than {minNum} days',
  'ACTIVITY.MANAGE.CREATE.ENTER.MIN.DAY.TIPS':
    'Number of days cannot be smaller than the delivery frequency',
  'ACTIVITY.MANAGE.CREATE.DAY': 'Day(s)',
  'ACTIVITY.MANAGE.CREATE.SPECIFIED.SCHEDULE': 'Custom schedule',
  'ACTIVITY.MANAGE.CREATE.TOTAL.CYCLES.NUMBER':
    'Total number of cycles: <b>{num}</b>',

  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.STOP.DELIVERY.TIME': 'Set end time',
  'ACTIVITY.MANAGE.CREATE.BY.USER.TIME.ZONE': 'Region Fixed Time',
  'ACTIVITY.MANAGE.CREATE.BY.USER.TIME.ZONE.TIPS':
    'Recipients with no region information will be set to UTC+00:00 time zone.',

  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION': 'Local delivery time',
  'ACTIVITY.MANAGE.CREATE.OPTIMAL.SENDING.TIME': 'Optimal delivery time',
  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION.TIPS':
    'Select the delivery date and SmartLink will recommend the best delivery time for each different region.',
  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION.DESC':
    'Set the sending time at least 24 hours in advance to get the optimal sending time that maximizes engagement.',
  'ACTIVITY.MANAGE.CREATE.EARLIEST.DELIVERY.TIME':
    'Earliest delivery start time',
  'ACTIVITY.MANAGE.CREATE.SHOW.SUGGESTED.SCHEDULE': 'Show suggested schedule',
  'ACTIVITY.MANAGE.CREATE.SET.START.DELIVERY.TIME':
    'Set delivery start time (local time)',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SET.START.DELIVERY.TIME':
    'Set the delivery start time',
  'ACTIVITY.MANAGE.CREATE.SET.START.DELIVERY.DATE': 'Set delivery start date',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SET.START.DELIVERY.DATE':
    'Set the delivery start date',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.COUNTRY.REGION': 'Enter a region name',
  'ACTIVITY.MANAGE.SCHEDULE.START.TIME.COMPARE.TIPS':
    'The start time cannot be later than the end time',
  'ACTIVITY.MANAGE.SCHEDULE.STOP.TIME.COMPARE.TIPS':
    'The end time cannot be later than the start time',

  'ACTIVITY.MANAGE.CREATE.START.DELIVERY.TIME1':
    'Delivery start time (Local time zone)',
  'ACTIVITY.MANAGE.CREATE.START.DELIVERY.TIME2': 'Delivery start time',
  'ACTIVITY.MANAGE.CREATE.DELIVERED.QUANTITY': 'Delivery count',
  'ACTIVITY.MANAGE.CREATE.DELIVERED.PROPORTION': 'Delivery rate',
  'ACTIVITY.MANAGE.CREATE.PLEASE.COUNTRY.REGION.DELIVERY':
    'Set the delivery start time for this region',
  'ACTIVITY.MANAGE.CREATE.DELIVERY.CYCLE': 'Delivery frequency',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.DELIVERY.CYCLE': 'Set send frequency',
  'ACTIVITY.MANAGE.CREATE.SINGLE.TIME': 'Send once',
  'ACTIVITY.MANAGE.CREATE.EVERY.DAY': 'Send daily',
  'ACTIVITY.MANAGE.CREATE.WEEKLY': 'Send weekly',
  'ACTIVITY.MANAGE.CREATE.MONTHLY': 'Send monthly',

  // 禁发时段设置
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.SETTING': 'Email delivery blockout',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD': 'Email delivery blockout',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.SETTING.TIPS':
    "Set a period during which emails will not be delivered to each region. Recipients in 'Unknown' regions are unaffected by the blockout.",
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM': 'Start',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO': 'End',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TOTAL': 'Total',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.HOUR.MINUTES':
    '{hours} hour(s) and {minutes} minute(s)',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.HOUR': '{hours} hour(s)',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.MINUTES': '{minutes} minute(s)',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM.TIME.COMPARE.TIPS':
    'The start time cannot be later than the end time',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO.TIME.COMPARE.TIPS':
    'The end time cannot be earlier than the start time',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM.EQ.TIME.TIPS':
    'The start time cannot be equal to the end time',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO.EQ.TIME.TIPS':
    'The end time cannot be equal to the start time',

  // 审批管理 - 列表
  'ACTIVITY.MANAGE.APPROVAL.TITLE': 'Campaigns pending approval',
  'ACTIVITY.MANAGE.APPROVAL.ID': 'Campaign ID',
  'ACTIVITY.MANAGE.APPROVAL.NAME': 'Campaign name',
  'ACTIVITY.MANAGE.APPROVAL.CATEGORY': 'Category',
  'ACTIVITY.MANAGE.APPROVAL.REGULAR': 'Regular',
  'ACTIVITY.MANAGE.APPROVAL.TEST': 'A/B test',
  'ACTIVITY.MANAGE.APPROVAL.CYCLE': 'Recurring',
  'ACTIVITY.MANAGE.APPROVAL.START.TIME': 'Campaign start time',
  'ACTIVITY.MANAGE.APPROVAL.SUBMIT.TIME': 'Approval submission time',
  'ACTIVITY.MANAGE.APPROVAL.SUBMITTER': 'Requested by',
  'ACTIVITY.MANAGE.APPROVAL.STATUS': 'Status',
  'ACTIVITY.MANAGE.APPROVAL.TIME': 'Time of approval',
  'ACTIVITY.MANAGE.APPROVER': 'Approved by',
  'ACTIVITY.MANAGE.TO.BE.APPROVED': 'Pending',
  'ACTIVITY.MANAGE.PASSED': 'Approved',
  'ACTIVITY.MANAGE.REJECTED': 'Rejected',
  'ACTIVITY.MANAGE.TO.APPROVE': 'Approve',
  'ACTIVITY.MANAGE.DISABLED': 'Disabled',

  // 审批管理 - 详情
  'ACTIVITY.MANAGE.CURRENT.PROGRESS': 'Current progress',
  'ACTIVITY.MANAGE.APPLICATION.RELEASE': 'Request campaign launch',
  'ACTIVITY.MANAGE.UNDER.APPROVAL': 'Pending approval',
  'ACTIVITY.MANAGE.APPROVAL.ADOPT': 'Approved (Launched)',
  'ACTIVITY.MANAGE.APPROVAL.FAIL': 'Rejected',
  'ACTIVITY.MANAGE.MODIFY.ACTIVITY.REAPPLICATION':
    'Modify campaign and submit again',

  'ACTIVITY.MANAGE.APPLICATION.OVERVIEW': 'Request overview',
  'ACTIVITY.MANAGE.APPLICANT': 'Requested by',
  'ACTIVITY.MANAGE.APPLICATION.TIME': 'Time of request',
  'ACTIVITY.MANAGE.EDITED.BY': 'Last edit by',
  'ACTIVITY.MANAGE.REJECTION.RECORD': 'Rejection log',
  'ACTIVITY.MANAGE.REJECTION.NUMBER':
    'Rejected <span class="tea-text-danger">{rejectTimes}</span> times',

  'ACTIVITY.MANAGE.APPROVAL.MODAL.TITLE': 'Decision on request',
  'ACTIVITY.MANAGE.APPROVAL.RESULTS': 'Result',
  'ACTIVITY.MANAGE.APPROVAL.REASON.1': 'Comment',
  'ACTIVITY.MANAGE.APPROVAL.REASON.2': 'Comment <span>(optional)</span>',
  'ACTIVITY.MANAGE.PLEASE.ENTER.APPROVAL.REASONS': 'Enter your comments',

  'ACTIVITY.MANAGE.UPDATE.ON': 'Last update:',
  'ACTIVITY.MANAGE.OVER.MILLION.TIPS':
    "If the number of recipients exceeds 1 million, please contact <span class='color-primary'>{customerServiceEmail}</span> to confirm this project's email sending capacity before launching the campaign. Otherwise the campaign could get interrupted if the limit is reached.",

  // WhatsApp hover文案
  'ACTIVITY.WHATSAPP.LIST.DRAFT.NOTE':
    'Campaign has not yet been launched. It can still be edited before launching or submitting it for approval.',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED.NOTE':
    'Campaign has been scheduled and is currently waiting for the scheduled delivery time.',
  'ACTIVITY.WHATSAPP.LIST.SENDING.ONGOING.NOTE':
    'Campaign is delivering messages since the scheduled delivery time has passed.',
  'ACTIVITY.WHATSAPP.LIST.PAUSED.NOTE':
    'Campaign has been paused manually and is currently not delivering messages.',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED.NOTE':
    'Ongoing campaign, but delivery was interrupted because there was an issue (e.g. Account limited). ',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED.NOTE': 'Campaign has been completed.',
  'ACTIVITY.WHATSAPP.LIST.TERMINATED.NOTE': 'Campaign was terminated manually.',
  // hover标题(补充)
  'ACTIVITY.WHATSAPP.LIST.SENDING': 'Sending/Ongoing',
  'ACTIVITY.WHATSAPP.LIST.PAUSEDTIP': 'Paused',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED': 'Interrupted',

  'ACTIVITY.MANAGE.CONTENT.VERIFY.KEYS.TIPS': 'Placeholder must be created',
  'ACTIVITY.MANAGE.CONTENT.VERIFY.ATTRIBUTES.TIPS':
    'The default value of the contact attribute is not set.',
  'ACTIVITY.MANAGE.CONTENT.CONTAINS.ATTRIBUTES.TIPS':
    'The template contains static placeholders,',
  'ACTIVITY.MANAGE.CONTENT.CONTAINS.ATTRIBUTES.DES':
    'Using up placeholders will cause the campaign to pause. Please check if the placeholder assignment meets the campaign requirements.',
};
